import { _ as i } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.string.small-23219181.js";
import u from "styled-components";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "react";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as p } from "./getMetrics-953aa4f8.js";
import { jsx as m } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./string-html-forced-a746405b.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
var v = ["$size"], s = ["$size"], c = ["$type"], d = ["$size"], h = ["size", "type"], $ = /* @__PURE__ */ u.div.withConfig({
  displayName: "avatarNew__AvatarContainer",
  componentId: "h0e285-0"
})(["box-sizing:", ";display:", ";justify-content:", ";align-items:", ";height:", ";width:", ";border-radius:", ";text-align:", ";background-color:", ";"], function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.avatar.AvatarContainer.boxSizing;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.avatar.AvatarContainer.display;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.avatar.AvatarContainer.justifyContent;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.avatar.AvatarContainer.alignItems;
}, function(t) {
  var e, a = t.$size, n = i(t, v);
  return n == null || (e = n.theme) == null ? void 0 : e.components.avatar.AvatarContainer.height[a || "default"];
}, function(t) {
  var e, a = t.$size, n = i(t, s);
  return n == null || (e = n.theme) == null ? void 0 : e.components.avatar.AvatarContainer.width[a || "default"];
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.avatar.AvatarContainer.borderRadius;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.avatar.AvatarContainer.textAlign;
}, function(t) {
  var e, a = t.$type, n = i(t, c);
  return n == null || (e = n.theme) == null ? void 0 : e.components.avatar.AvatarContainer.backgroundColor[a || "default"];
}), f = /* @__PURE__ */ u.span.withConfig({
  displayName: "avatarNew__AvatarContent",
  componentId: "h0e285-1"
})(["display:", ";box-sizing:", ";justify-content:", ";align-items:", ";", " color:", ";text-align:", ";font-style:", ";"], function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.avatar.AvatarContent.display;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.avatar.AvatarContent.boxSizing;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.avatar.AvatarContent.justifyContent;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.avatar.AvatarContent.alignItems;
}, function(t) {
  var e, a, n, l, o = t.$size, r = i(t, d);
  switch (o) {
    case "large":
      return r == null || (e = r.theme) == null ? void 0 : e.components.avatar.AvatarContent.textSize.large;
    case "small":
      return r == null || (a = r.theme) == null ? void 0 : a.components.avatar.AvatarContent.textSize.small;
    case "extraSmall":
      return r == null || (n = r.theme) == null ? void 0 : n.components.avatar.AvatarContent.textSize.extraSmall;
    case "medium":
    default:
      return r == null || (l = r.theme) == null ? void 0 : l.components.avatar.AvatarContent.textSize.medium;
  }
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.avatar.AvatarContent.color;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.avatar.AvatarContent.textAlign;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.avatar.AvatarContent.fontStyle;
});
function X(t) {
  var e = t.size, a = e === void 0 ? "medium" : e, n = t.type, l = n === void 0 ? "primary" : n, o = i(t, h), r = p({
    label: "Avatar"
  });
  return /* @__PURE__ */ m($, Object.assign({
    $size: a,
    $type: l
  }, o, r, {
    children: /* @__PURE__ */ m(f, Object.assign({
      role: "content",
      $size: a
    }, o, {
      children: o.initials
    }))
  }));
}
export {
  X as AvatarNew
};
